export function Textarea({ className = "", ...props }) {
    const classes = ["aurora-textarea", className].filter(Boolean).join(" ")
    return <textarea className={classes} {...props} />
}

export default Textarea




